import { render, staticRenderFns } from "./Borrow.vue?vue&type=template&id=6e103150&"
import script from "./Borrow.vue?vue&type=script&lang=js&"
export * from "./Borrow.vue?vue&type=script&lang=js&"
import style0 from "./Borrow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports